import React from "react";
import { Table, TableCard } from "@vctors/vctors-untitled-ui";
import { PurchaseOrderDetails } from "../../../../../contract/dtos/purchaseRequest";
import { PriceDisplay } from "../../../components/priceDisplay";

interface ProductTableProps {
  products: PurchaseOrderDetails;
  orderSummary: PurchaseOrderDetails["order_summary"];
}

export const ProductTable: React.FC<ProductTableProps> = ({ products }) => {
  return (
    <TableCard.Root className="bg-white !ring-[#E9EAEB] !ring-1 !shadow-none !border-none">
      <Table aria-label="Products" className="bg-white">
        <Table.Header className="bg-[#FAFAFA] text-[#717680]">
          <Table.Head id="product" label="Product details" />
          <Table.Head id="image" label="" />
          <Table.Head id="unitPrice" label="Unit Price" />
          <Table.Head id="quantity" label="Qty" />
          <Table.Head id="totalPrice" label="Total Price" />
        </Table.Header>

        <Table.Body>
          {products?.items?.map((product) => (
            <Table.Row
              key={product?.tenant_product?.id}
              className="border-t border-[#E9EAEB]"
            >
              <Table.Cell>
                <div className="flex-1">
                  <div className="text-xs text-gray-500 mb-1">
                    {
                      product?.tenant_product?.catalog_info
                        ?.product_categories?.[0]?.category?.name
                    }
                  </div>
                  <div className="font-medium text-gray-900 mb-1">
                    {product?.tenant_product?.tenant_product_name !== ""
                      ? product?.tenant_product?.tenant_product_name
                      : product?.tenant_product?.catalog_info?.name}
                  </div>
                  <div className="text-xs text-gray-600 ">
                    {product?.tenant_product?.catalog_info?.feature_values
                      ?.map(
                        (feature) =>
                          `${feature?.feature_Name} - ${feature?.featureVariant?.variant_name}`
                      )
                      .join(" - ")}
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className="w-12 h-12 rounded-lg overflow-hidden">
                  <img
                    src={
                      product?.tenant_product?.catalog_info?.product_images?.[0]
                        ?.image_path
                    }
                    alt={
                      product?.tenant_product?.tenant_product_name !== ""
                        ? product?.tenant_product?.tenant_product_name
                        : product?.tenant_product?.catalog_info?.name
                    }
                    className="w-full h-full object-cover"
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <PriceDisplay
                  currentPrice={product.price_per_unit?.price}
                  originalPrice={product.tenant_product?.catalog_info?.price}
                  isUnitPrice={false}
                />
              </Table.Cell>
              <Table.Cell>
                <div className="w-20">
                  <select
                    value={product.quantity}
                    onChange={() => {}}
                    disabled={true}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                </div>
              </Table.Cell>
              <Table.Cell>
                <PriceDisplay
                  currentPrice={product.price.price}
                  originalPrice={
                    product?.tenant_product?.catalog_info?.price *
                    product?.quantity
                  }
                  isUnitPrice={false}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </TableCard.Root>
  );
};
